import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import PricingCalculator from "../components/PricingCalculator";
import About from "../components/About";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <PricingCalculator />
        <About />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
